import { inject } from '@angular/core';
import { CanActivateFn, RedirectCommand, Router } from '@angular/router';
import { ConfigService } from '@rxap/config';
import { isRequestApiEnabled } from '../is-request-api-enabled';
import { logGuardResult } from './guard-logger';

/**
 * Redirects deep links to the Request API source screen back to the source
 * selection when no Request API server is configured (`api.iirds.enabled`
 * falsy).
 */
export const requestApiEnabledGuard: CanActivateFn = () => {
  const configService = inject(ConfigService);
  const router = inject(Router);

  if (isRequestApiEnabled(configService)) {
    return logGuardResult('requestApiEnabledGuard', true, {
      reason: 'Request API enabled',
    });
  }

  return logGuardResult(
    'requestApiEnabledGuard',
    new RedirectCommand(router.parseUrl('/upload')),
    { reason: 'Request API disabled via api.iirds.enabled' }
  );
};
